import { useState } from "react";

import { default as api } from "../../api/uploadApi";
import DialogWrapper from "../dialogs/DialogWrapper";
import CloseButton from "../buttons/CloseButton";
import CircleButton from "../buttons/CircleButton";
import PreviewFileDialog from "../dialogs/PreviewFileDialog";

export const TechnicianLogFilesDialog = ({ isOpen, onClose, files = [] }) => {
  const [isDownloading, setIsDownloading] = useState({});
  const [downloadProgress, setDownloadProgress] = useState({});
  const [downloadErrors, setDownloadErrors] = useState({});
  const [previewFile, setPreviewFile] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const handleDownload = async (file) => {
    try {
      setIsDownloading({ ...isDownloading, [file.id]: true });
      setDownloadErrors({ ...downloadErrors, [file.id]: null });

      await api.downloadFile(file.id, {
        originalName: file.name,
        onDownloadProgress: (progressEvent) => {
          setDownloadProgress({
            ...downloadProgress,
            [file.id]: Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            ),
          });
        },
      });

      setIsDownloading({ ...isDownloading, [file.id]: false });
      setDownloadProgress({ ...downloadProgress, [file.id]: null });
    } catch (e) {
      setDownloadErrors({ ...downloadErrors, [file.id]: e.message });
      setIsDownloading({ ...isDownloading, [file.id]: false });
      setDownloadProgress({ ...downloadProgress, [file.id]: null });
    }
  };

  const handlePreview = (file) => {
    setPreviewFile(file);
    setIsPreviewOpen(true);
  };

  const handlePreviewClose = () => {
    setIsPreviewOpen(false);
    setPreviewFile(null);
  };

  if (!isOpen) return null;

  return (
    <>
      <DialogWrapper onClick={onClose}>
        <div
          className="relative bg-white rounded-xl w-[590px] px-[50px] py-[40px] max-h-[100vh] overflow-y-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <CloseButton onClick={onClose} />

          <h3 className="text-xl font-bold text-center mb-6">
            Soubory záznamu technika
          </h3>

          <div className="space-y-3">
            {files.map((file) => (
              <div
                key={file.id}
                className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
              >
                <div className="flex-1">
                  <p className="font-medium">{file.name}</p>
                  <p className="text-sm text-gray-500">
                    {file.size && `${(file.size / 1024).toFixed(1)} KB`}
                    {file.extension && ` • ${file.extension}`}
                  </p>

                  {downloadProgress[file.id] && (
                    <div className="mt-1">
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div
                          className="bg-blue-600 h-2 rounded-full"
                          style={{ width: `${downloadProgress[file.id]}%` }}
                        ></div>
                      </div>
                      <p className="text-xs text-blue-600 mt-1">
                        {downloadProgress[file.id]}%
                      </p>
                    </div>
                  )}

                  {downloadErrors[file.id] && (
                    <p className="text-sm text-red-500 mt-1">
                      Error: {downloadErrors[file.id]}
                    </p>
                  )}
                </div>

                <div className="flex items-center gap-2">
                  <CircleButton
                    icon="/images/download.svg"
                    primary
                    iconSize="12px"
                    onClick={() => handleDownload(file)}
                    disabled={isDownloading[file.id]}
                  />
                  <CircleButton
                    primary
                    className="py-2 px-2 mr-2"
                    icon="/images/preview.svg"
                    iconSize="12px"
                    onClick={() => handlePreview(file)}
                    title="File Preview"
                  />
                </div>
              </div>
            ))}
          </div>

          {files.length === 0 && (
            <p className="text-center text-gray-500">
              Žádné soubory k zobrazení
            </p>
          )}
        </div>
      </DialogWrapper>
      <PreviewFileDialog
        isPreviewOpen={isPreviewOpen}
        isOpen={isPreviewOpen}
        onClose={handlePreviewClose}
        file={previewFile}
        isLocalFile={false}
      />
    </>
  );
};
